import { render, staticRenderFns } from "./footerCom.vue?vue&type=template&id=324b7e9e&scoped=true"
import script from "./footerCom.vue?vue&type=script&lang=js"
export * from "./footerCom.vue?vue&type=script&lang=js"
import style0 from "./footerCom.vue?vue&type=style&index=0&id=324b7e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324b7e9e",
  null
  
)

export default component.exports